/**
 * Provides a configuration boolean flag to show or hide the term tab into Passport UI
 */
// eslint-disable-next-line import/prefer-default-export
export function isPerformanceInsightsTabDisabled() {
  return false;
}
